import { forwardRef } from "react";

import { cn } from "../index";

/* -------------------------------------------------------------------------------------------------
 * Root
 * -----------------------------------------------------------------------------------------------*/
type RootProps = React.ComponentPropsWithRef<"div">;
const Root = forwardRef<HTMLDivElement, RootProps>(({ className, ...props }, forwardedRef) => (
  <div
    {...props}
    ref={forwardedRef}
    role="alert"
    aria-live="assertive"
    className={cn("gap-5 py-17.5 mx-auto flex max-w-[80%] flex-col items-center", className)}
  />
));

/* -------------------------------------------------------------------------------------------------
 * Title
 * -----------------------------------------------------------------------------------------------*/
type TitleProps = React.ComponentPropsWithRef<"h2">;
const Title = forwardRef<HTMLHeadingElement, TitleProps>(({ className, ...props }, forwardedRef) => (
  <h2
    {...props}
    ref={forwardedRef}
    className={cn("font-semibold md:text-[160px] text-[130px] text-shadow-[var(--text-shadow-error)]", className)}
  />
));

/* -------------------------------------------------------------------------------------------------
 * Description
 * -----------------------------------------------------------------------------------------------*/
type DescriptionProps = React.ComponentPropsWithRef<"p">;
const Description = forwardRef<HTMLParagraphElement, DescriptionProps>(({ className, ...props }, forwardedRef) => (
  <p {...props} ref={forwardedRef} className={cn("md:text-xl text-base", className)} />
));

export { Root, Title, Description };
export type { RootProps, TitleProps, DescriptionProps };
